import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { TwitterPicker } from 'react-color';

import './CommerceButtonColorSelector.css';

function CommerceButtonColorSelector(props) {
  const {
    initialColor,
    parameter,
    patchFunction,
    linkId,
  } = props;

  const [currentColor, setCurrentColor] = useState(null);

  useEffect(() => {
    if (!currentColor && initialColor) {
      setCurrentColor(initialColor);
    }
  }, []);

  const onColorChange = color => {
    setCurrentColor(color.hex);
    const form = new FormData();
    form.append(parameter, color.hex);
    patchFunction(linkId, form);
  };

  return (
    <div className="commerce-button-color-selector__component">
      <div className="text">
        Choose the color visitors will see for links and buttons on your page
      </div>

      <TwitterPicker
        key={`commerce-button-color-picker-key-${linkId}`}
        color={currentColor || '#bebebe'}
        onChangeComplete={onColorChange}
        disableAlpha
      />

    </div>
  );
}

CommerceButtonColorSelector.propTypes = {
  patchFunction: PropTypes.func.isRequired,
  key: PropTypes.string.isRequired,
  parameter: PropTypes.string.isRequired,
  initialColor: PropTypes.string.isRequired,
  linkId: PropTypes.number.isRequired,
};

export default CommerceButtonColorSelector;
